module.exports = __webpack_public_path__ + "media/images/ln/horoscope_8-17a7f28bb0cca1b0c678a65435b5e1f4.png";